"use client";
import {
  Box,
  Button,
  Divider,
  Heading,
  SimpleGrid,
  GridItem,
  HStack,
  VStack,
  Text,
  Stack,
} from "@chakra-ui/react";
import Link from "next/link";
import Image from "next/image";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {scrollToElement} from "@/utils/scrollToElement";
import {PlainHoverEffect} from "styles/hoverPresets";
import {
  ISV_DESKTOP_DATA,
  FOOTER_NOTE,
} from "@/views/pricing/components/tables/isvDektops/constants";

const ISVDesktopCard = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Box>
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        ISV Desktops Pricing
      </Heading>
      <SimpleGrid columns={{base: 1, sm: 2, md: 4}} spacing={8} mb={6}>
        {ISV_DESKTOP_DATA.slice(0, 8).map((server) => (
          <GridItem
            key={server.sku}
            borderWidth="1px"
            borderRadius="20px"
            boxShadow={"lg"}
            _hover={PlainHoverEffect}
          >
            <VStack
              spacing={1}
              color="white"
              py={2}
              backgroundColor={"primary.200"}
              borderTopRadius="20px"
            >
              <HStack spacing={2}>
                <Box
                  h="2rem"
                  position="relative"
                  w="2.2rem"
                  display={"flex"}
                  alignItems={"center"}
                  gap="2px"
                >
                  <Image src={server.image} alt="image" style={{objectFit: "contain"}} />
                </Box>
                <Text
                  fontWeight={600}
                  fontSize={{base: "md", md: "lg", xl: "md", "2xl": "lg"}}
                >
                  {server.processor}
                </Text>
              </HStack>
              <Text fontWeight={600} fontSize={{base: "sm", xl: "sm"}}>
                {server.sku}
              </Text>
              <Text fontWeight={600} fontSize={"xl"}>
                {server.price}
              </Text>
            </VStack>
            <VStack
              spacing={2}
              color="text.100"
              backgroundColor={"white"}
              p={4}
              align={"start"}
              borderBottomRadius={"20px"}
            >
              <Box>
                <Text as="span" fontWeight={600}>
                  GPU :{" "}
                </Text>
                <Text as="span">{server.gpu}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Memory :{" "}
                </Text>
                <Text as="span">{server.memory}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Base Clock/Boost :{" "}
                </Text>
                <Text as="span">{server.basecock_boost}</Text>
              </Box>
              <Box>
                <Text as="span" fontWeight={600}>
                  Disk :{" "}
                </Text>
                <Text as="span">{server.disk}</Text>
              </Box>
            </VStack>
          </GridItem>
        ))}
      </SimpleGrid>
      <Stack spacing={4} align={"center"}>
        <Text variant={TextVariant} color="text.100" textAlign="center">
          Looking for more options? Check out our full{" "}
          <Link
            href="/pricing?table=isv-desktops"
            style={{textDecoration: "underline", color: "#1E87F0", fontWeight: 700}}
          >
            Pricing Catalog{" "}
          </Link>
          and choose the best fit for your needs.
        </Text>
        <Box textAlign={"center"}>
          <Text as="span" color="text.100" fontWeight={600}>
            NOTE :{" "}
          </Text>
          <Text as="span" color="text.100" textAlign={"center"}>
            {FOOTER_NOTE}
          </Text>
        </Box>
        <Button
          variant={BUTTON_VARIANTS.IDEAL}
          onClick={() => scrollToElement("contact-us", 120)}
          mt={3}
          alignSelf={"center"}
          justifySelf={"center"}
          placeSelf={"center"}
          px={6}
        >
          Ready To Buy?
        </Button>
        <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
      </Stack>
    </Box>
  );
};

export default ISVDesktopCard;
